export default __webpack_public_path__ + "static/media/Group 1171277149.dae5944b.svg";